export const EMPTY_VALUE_REGEX =
  /^<[a-zA-Z0-9]+>(?:<br>|&nbsp;)?<\/[a-zA-Z0-9]+>$/;
